import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { addRemoveError, getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';

export const getDatiBilancioGroup = (form: FormGroup): FormGroup =>
    getGroup(form, formPaths.datiBilancio);

export const getDatiBilancioBisControl = (form: FormGroup, path: string) =>
    getControl(form, `${formPaths.datiBilancio}.${path}`);

export const checkRequiredFieldWithTipoBilancio = (
    form: FormGroup,
    targetPath: string,
    tipoBilancioPath: string,
    tipoBilancioCheckValue: string
): void => {
    const datiBilancioGroup = getDatiBilancioGroup(form);
    const targetControl = getControl(datiBilancioGroup, targetPath);
    const tipoBilancio: string = getControl(datiBilancioGroup, tipoBilancioPath)?.value;
    const showError = isNilOrEmpty(targetControl?.value) && tipoBilancio === tipoBilancioCheckValue;
    const errors = targetControl.errors ? targetControl.errors : {};
    const targetPathParts = targetPath?.split('.');
    addRemoveError(showError, errors, targetPathParts[targetPathParts?.length - 1], {
        status: REQUIRED_STATUS,
    });
    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};
